import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }

import { watch } from "vue";
import { FieldComposable, fieldProps } from "./field.composable";
import Message from "@/components/common/Message.vue";
import { getMessage } from "@/core/validation";
import MarkdownEditor from "@/markdown/MarkdownEditor.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldMarkdown',
  props: {
  ...fieldProps,
  modelValue: {
    type: String,
    default: ""
  },
  placeholder: {
    type: String
  },
  uploadPath: {
    type: String
  }
},
  emits: [
  "update:modelValue",
  "enter",
  "input",
  "escape",
  `key.${String}`,
  `key.ctrl.${String}`
],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { fieldValue, update, enter, escape, key, name } =
  FieldComposable<string>(props.modelValue, emit, props.label, props.prop);

watch(
  () => props.modelValue,
  (v) => {
    fieldValue.value = `${v}`;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["field field-long", [
      { invalid: props.validation.$invalid && props.validation.$dirty },
      props.styling
    ]])
  }, [
    (!props.hideLabel)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (
          props.validation &&
          props.validation.$invalid &&
          !props.validation.$dirty
        )
            ? (_openBlock(), _createElementBlock("sup", _hoisted_2, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(MarkdownEditor, {
      modelValue: _unref(fieldValue),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(fieldValue) ? (fieldValue).value = $event : null)),
      "upload-path": __props.uploadPath,
      onInput: _unref(update),
      onKeyup: _unref(key),
      onKeydown: [
        _withKeys(_withModifiers(_unref(enter), ["exact"]), ["enter"]),
        _withKeys(_withModifiers(_unref(escape), ["exact"]), ["escape"])
      ],
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (props.validation.$touch()))
    }, null, 8, ["modelValue", "upload-path", "onInput", "onKeyup", "onKeydown"]),
    _createVNode(Message, {
      type: "alert",
      styling: props.messageStyling,
      message: _unref(getMessage)(props.validation),
      show: props.validation.$invalid && props.validation.$dirty,
      onDismiss: _cache[2] || (_cache[2] = ($event: any) => (props.validation.$reset()))
    }, null, 8, ["styling", "message", "show"])
  ], 2))
}
}

})